var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriven(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_468_10500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 17C5 8.16344 12.1634 1 21 1H45C53.8366 1 61 8.16344 61 17V41C61 49.8366 53.8366 57 45 57H21C12.1634 57 5 49.8366 5 41V17Z",
    fill: "#1B5E20",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 31.0002C24.8108 31.0008 24.6252 30.9477 24.4649 30.8471C24.3047 30.7465 24.1762 30.6025 24.0945 30.4318C24.0129 30.2611 23.9813 30.0707 24.0035 29.8828C24.0257 29.6949 24.1008 29.5171 24.22 29.3702L34.12 19.1702C34.1943 19.0844 34.2955 19.0265 34.407 19.0059C34.5185 18.9853 34.6337 19.0032 34.7337 19.0567C34.8337 19.1102 34.9126 19.1961 34.9573 19.3003C35.0021 19.4045 35.0101 19.5208 34.98 19.6302L33.06 25.6502C33.0034 25.8017 32.9844 25.9647 33.0046 26.1252C33.0248 26.2857 33.0837 26.4388 33.1761 26.5716C33.2685 26.7043 33.3918 26.8127 33.5353 26.8873C33.6788 26.962 33.8382 27.0007 34 27.0002H41C41.1892 26.9995 41.3748 27.0526 41.535 27.1532C41.6953 27.2538 41.8238 27.3978 41.9054 27.5685C41.9871 27.7392 42.0187 27.9296 41.9965 28.1175C41.9743 28.3054 41.8992 28.4832 41.78 28.6302L31.88 38.8302C31.8057 38.9159 31.7045 38.9738 31.593 38.9944C31.4815 39.0151 31.3663 38.9972 31.2663 38.9437C31.1663 38.8902 31.0874 38.8043 31.0427 38.7001C30.9979 38.5958 30.9899 38.4795 31.02 38.3702L32.94 32.3502C32.9966 32.1986 33.0156 32.0356 32.9954 31.8752C32.9752 31.7147 32.9163 31.5615 32.8239 31.4287C32.7315 31.296 32.6082 31.1876 32.4647 31.113C32.3212 31.0384 32.1617 30.9996 32 31.0002H25Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_468_10500",
    x: 0,
    y: 0,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_468_10500"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_468_10500"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_468_10500"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_468_10500",
    result: "effect2_dropShadow_468_10500"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_468_10500",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriven);
export default __webpack_public_path__ + "static/media/Driven.a49c6ec920893eee6bc35a387ffdf578.svg";
export { ForwardRef as ReactComponent };